module.exports = __webpack_public_path__ + "static/banner-two-shape3-52612ba66371ae91e67f7a22fd174b9e.png";